import Vue from 'vue'
import validator from './validator'
import title from '@/directives/title'


Vue.directive('validator', validator)
Vue.directive('title', title)